interface ProductImageProps {
  imageUrl: string | null;
  productName: string;
}

const ProductImage = ({ imageUrl, productName }: ProductImageProps) => {
  return (
    <div>
      <img
        src={imageUrl || ''}
        alt={productName}
        className="w-full rounded-lg object-cover aspect-square"
      />
    </div>
  );
};

export default ProductImage;